import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {
  Text,
  Icon,
} from 'athenaeum';

import Section from 'components/Section';
import Logo from '../Logo';
import styles from './affiliate_nav.module.scss';

const affiliateText = affiliateName => (
  <Text
    size={6}
    font="a"
    className={styles.text}
  >
    <Logo
      className={styles.logo}
    />
    { affiliateName && <span className={styles.plus}> + </span> }
    <span className={styles['affiliate-name']}> { affiliateName } </span>
  </Text>
);

const contactText = contactInformation => (
  <Text
    className={cx(
      styles['contact-info'],
      styles['contact-info-wrapper']
    )}
    size={8}
    font="b"
    bold
  >
    <Icon
      icon="phoneRebrand"
      height="24px"
      width="24px"
      inline="left"
    />
    Call us at {contactInformation}
  </Text>
);

const AffiliateNav = (props) => {
  const {
    affiliateName,
    contactInformation
  } = props;

  return (
    <nav
      className={styles.wrapper}
    >
      <Section
        className={styles.section}
      >
        <div
          className={styles.container}
        >
          { affiliateText(affiliateName) }
          { contactInformation && contactText(contactInformation) }
        </div>
      </Section>
    </nav>
  );
};

AffiliateNav.propTypes = {
  affiliateName: PropTypes.string,
  contactInformation: PropTypes.string,
};

export default AffiliateNav;



// WEBPACK FOOTER //
// ../src/templates/MainNav/AffiliateNav/index.js